import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles()((theme: Theme) => ({
  noContentSelected: {
    '& button': {
      textIndent: 'inherit',
      padding: '6px 16px',
      marginTop: theme.spacing(2),
    },
		
		'& p:first-of-type': {
				color: theme.palette.error.main,
		}
  },
}));
